import React from 'react';

import { DynamicComponent } from 'ctm-components';
import { ResponsiveLayout } from '@comparethemarketau/manor-layout';

import { PageStyledWrapper } from '../products/page_styled_wrapper';

import { PolicyProductSingleColumn } from './policy_product_single_column';
import { PolicyProductTwoColumn } from './policy_product_two_column';

const MoreInfoPageMain = () => {
    return (
        <DynamicComponent component={(
            <PageStyledWrapper className={'test-moreInfoPage-main'}>
                <ResponsiveLayout upTo={'sm'}>
                    <PolicyProductSingleColumn />
                </ResponsiveLayout>
                <ResponsiveLayout isFrom={'md'}>
                    <PolicyProductTwoColumn />
                </ResponsiveLayout>
            </PageStyledWrapper>
        )} />
    );
};

export { MoreInfoPageMain };
